const Bg = () => {
  return (
    <>
      <div className="container" />
      <style jsx>{`
        .container {
          background-color: var(--white);
          height: 8px;
          border: 1px solid var(--clr-tertiary-1);
          border-radius: var(--rd-6);
          width: calc(100% + 22px);
        }
      `}</style>
    </>
  );
};

export default Bg;
